import React, { useEffect, useState } from 'react';

// One tab per recipient in the live preview plan, each showing the exact
// HTML that person would receive — rendered in a sandboxed iframe (srcDoc)
// rather than dangerouslySetInnerHTML, same as SuggestionPreviewTabs.js.
//
// Deliberately renders `previewPlan` fetched from the real backend
// (POST /admin/reminders/preview → buildReminderPlan, same render path
// /reminders/send uses) rather than a client-side placeholder mirror —
// this reuses the exact same code that decides who's still pending, which
// fields are safe to show, and how the dynamic {{pendingPeopleBlock_<Label>}}
// / {{respondButton_<Label>}} placeholders resolve, so the preview can
// never drift from what actually sends. Matches SuggestionPreviewTabs.js's
// own reasoning for the same choice, not Matched Intros' hand-maintained
// client mirror.
const RemindersPreviewTabs = ({ previewPlan }) => {
  const [activeTabUserId, setActiveTabUserId] = useState('');

  const recipients = previewPlan?.recipients || [];

  useEffect(() => {
    if (recipients.length === 0) {
      setActiveTabUserId('');
      return;
    }
    if (!recipients.some((r) => r.userId === activeTabUserId)) {
      setActiveTabUserId(recipients[0].userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipients.map((r) => r.userId).join(',')]);

  if (recipients.length === 0) return null;

  const activeRecipient = recipients.find((r) => r.userId === activeTabUserId) || recipients[0];

  return (
    <div>
      <div className="as-card-meta" style={{ marginBottom: '0.4rem' }}>Who this will be sent to ({recipients.length}):</div>
      <div className="as-suggestion-recipient-tabs">
        {recipients.map((r) => (
          <button
            key={r.userId}
            type="button"
            className={`as-filter-tab ${activeTabUserId === r.userId ? 'as-filter-tab--active' : ''}`}
            onClick={() => setActiveTabUserId(r.userId)}
          >
            {r.firstName || r.userId}
          </button>
        ))}
      </div>

      <div className="as-suggestion-recipient-card">
        <div className="as-card-meta"><strong>To:</strong> {activeRecipient.firstName} ({activeRecipient.email})</div>
        <div className="as-card-meta"><strong>Subject:</strong> {activeRecipient.subject}</div>
        <iframe
          key={activeRecipient.userId}
          className="as-suggestion-preview-iframe"
          title={`Reminder email preview for ${activeRecipient.firstName || activeRecipient.userId}`}
          srcDoc={activeRecipient.htmlBody}
          sandbox=""
        />
      </div>
    </div>
  );
};

export default RemindersPreviewTabs;
